module.exports = new __parcel__URL__("okx.512858a0.png").toString();